import { FuelIcon, FuelTypography } from '@frete.com/fuel-react'
import { PlanItemProps } from '../types'
import * as Styled from '../styled'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import { FuelFlex } from '@frete.com/fuel-station-react'

const PlanItem = ({
  label,
  alignCenter = false,
  marginTop = false,
  spacingBottom = 12,
  badge,
  flexDirection = 'row',
  isErrorIcon = false,
  isAccordionItem,
}: PlanItemProps) => {
  const spacingBottomPx = `${spacingBottom}px`
  return (
    <Styled.Span alignCenter={alignCenter}>
      <FuelIcon
        size="micro"
        name={isErrorIcon ? 'error' : 'one-check'}
        iconStyle="filled"
        style={{
          color: isErrorIcon ? theme.color.icon.neutral.default : theme.color.background.success.default,
        }}
      />
      <FuelFlex
        defaultProps={{
          flexDirection: flexDirection,
          customMargin: `${marginTop ? '16px' : 0} 0 ${isAccordionItem ? 0 : spacingBottomPx} 0`,
          gap: isAccordionItem ? 'km0' : 'km1',
        }}
      >
        <FuelTypography weight="medium" size="body-sm">
          {label}
        </FuelTypography>
        {badge && <>{badge}</>}
      </FuelFlex>
    </Styled.Span>
  )
}

export default PlanItem
